import { makeApi, makeErrors } from "@zodios/core";
import z from "zod";

export type SignupWithEmailRequestType = z.infer<typeof SignupWithEmailRequestSchema>;
export type SignupWithEmailResponseType = z.infer<typeof SignupWithEmailResponseSchema>;
export type SigninWithEmailRequestType = z.infer<typeof SigninWithEmailRequestSchema>;
export type SigninWithEmailResponseType = z.infer<typeof SigninWithEmailResponseSchema>;
export type ConfirmEmailRequestType = z.infer<typeof ConfirmEmailRequestSchema>;
export type ConfirmEmailResponseType = z.infer<typeof ConfirmEmailResponseSchema>;
export type LogoutResponseType = z.infer<typeof LogoutResponseSchema>;
export type ResetPasswordRequestType = z.infer<typeof ResetPasswordRequestSchema>;
export type ResetPasswordResponseType = z.infer<typeof ResetPasswordResponseSchema>;
export type ChangePasswordRequestType = z.infer<typeof ChangePasswordRequestSchema>;
export type ChangePasswordResponseType = z.infer<typeof ChangePasswordResponseSchema>;

export const SignupWithEmailRequestSchema = z.object({
  email: z.string().email(),
  password: z.string()
});

export const SignupWithEmailResponseSchema = z.object({
  message: z.string()
});

export const SigninWithEmailRequestSchema = z.object({
  email: z.string().email(),
  password: z.string()
});

export const SigninWithEmailResponseSchema = z.object({
  message: z.string()
});

export const ConfirmEmailRequestSchema = z.object({
  confirmation_token: z.string()
});

export const ConfirmEmailResponseSchema = z.object({
  message: z.string()
});

export const LogoutResponseSchema = z.object({
  message: z.string()
});

export const ResetPasswordRequestSchema = z.object({
  email: z.string().email()
});

export const ResetPasswordResponseSchema = z.object({
  message: z.string()
});

export const ChangePasswordRequestSchema = z.object({
  reset_password_token: z.string(),
  password: z.string()
});

export const ChangePasswordResponseSchema = z.object({
  message: z.string()
});

const errors = makeErrors([
  {
    status: 400,
    description: "Bad request",
    schema: z
      .object({
        code: z.string(),
        message: z.string()
      })
      .passthrough()
  },
  {
    status: "default",
    description: "Default error",
    schema: z
      .object({
        code: z.string(),
        message: z.string()
      })
      .passthrough()
  }
]);

export const authApi = makeApi([
  {
    alias: "signupWithEmail",
    method: "post",
    path: "/signup/email",
    response: SignupWithEmailResponseSchema,
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: SignupWithEmailRequestSchema
      }
    ],
    errors
  },
  {
    alias: "signinWithEmail",
    method: "post",
    path: "/signin/email",
    response: SigninWithEmailResponseSchema,
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: SigninWithEmailRequestSchema
      }
    ],
    errors
  },
  {
    alias: "confirmEmail",
    method: "post",
    path: "/confirm_email",
    response: ConfirmEmailResponseSchema,
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: ConfirmEmailRequestSchema
      }
    ],
    errors
  },
  {
    alias: "logout",
    method: "post",
    path: "/logout",
    response: LogoutResponseSchema,
    errors
  },
  {
    alias: "v3accepted",
    method: "post",
    path: "/set_v3_accessed",
    response: z.object({
      message: z.string()
    }),
    errors
  },
  {
    alias: "resetPassword",
    method: "post",
    path: "/reset_password",
    response: ResetPasswordResponseSchema,
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: ResetPasswordRequestSchema
      }
    ],
    errors
  },
  {
    alias: "changePassword",
    method: "post",
    path: "/change_password",
    response: ChangePasswordResponseSchema,
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: ChangePasswordRequestSchema
      }
    ],
    errors
  }
]);
